module.exports = __webpack_public_path__ + "static/media/plane2.b94b555b.svg";